import { useEffect, useState } from 'react';
import { UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { EvaluationRoles } from '../../../commonTypes/user.types';

const useHttpGetEvaluationRolesOnMount = () => {
    const userApi: UserApi = useContainer(UserApi);
    const [data, setData] = useState<EvaluationRoles[]>([]);
    const [isReady, setIsReady] = useState(false);

    const { exec, abort } = userApi.getEvaluationRoles({
        onSuccess: res => setData(res.body),
        onFinally: () => setIsReady(true),
    });

    useEffect(() => {
        exec();
        return abort;
    }, []);
    return { isReady, data };
};

export default useHttpGetEvaluationRolesOnMount;
